import {ISearchParam} from "../definitions";
import {SearchParams} from "./params/search-params";


export class SearchController {
  private searchParams: SearchParams;
  private filterParams: SearchParams;


  constructor(private callback: Function) {
  }


  get hasConfig(): boolean {
    return this.searchParams && this.searchParams.json.length > 0;
  }


  get opts(): ISearchParam[] {
    return this.searchParams
      ? this.searchParams.json
      : [];
  }


  setSearchParams() {

  }


  setParams(searchParams: SearchParams,
            filterParams: SearchParams = null) {
    this.searchParams = searchParams;
    this.filterParams = filterParams;
  }


  onInputKeyPress(event: KeyboardEvent) {
    if (event.keyCode === 13) { // Enter
      this.notify();
    }
  }


  onSearchClick() {
    this.notify();
  }


  collectSearchParams(): ISearchParam[] {
    let result: ISearchParam[] = [];
    if (!this.hasConfig) {
      return result;
    }

    this.searchParams.json.forEach((opt: ISearchParam): void => {
      if (typeof opt.value === "undefined"
          || opt.value === null
          || opt.value === "") {
        return;
      }
      result.push(opt);
    });

    if (this.filterParams && this.filterParams.json.length > 0) {
      result = result.concat(this.filterParams.json);
    }
    return result;
  }

  private notify() {
    this.callback();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/search-controller.ts